module.exports = __webpack_public_path__ + "static/obvious_1-47bdf0959f4cd4f6327fada3b28d37d9.jpg";